import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {BraidDesignProvider} from "./components/BraidDesignProvider.tsx";
import {HelmetProvider} from "react-helmet-async";

/**
 * Adding root element to the DOM
 */
const rootElement = document.createElement("div");
rootElement.id = "root";
rootElement.style.width = "100%";

document.body.appendChild(rootElement);
document.body.style.overflow = "hidden";

console.log(`loading main.tsx`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <HelmetProvider>
      <BraidDesignProvider braidThemeName={"seekJobs"}>
        <App />
      </BraidDesignProvider>
      </HelmetProvider>
  </StrictMode>,
)
